import {readStorage} from "../../LocalStorage/helpers/readStorage";
import {StorageKey} from "../../../enums/StorageKey";
// eslint-disable-next-line import/no-cycle
import {L} from "../reducer";

export function getInitData(key) {
    switch (key) {
        case L.company_addresses:
            return {
                companyAddresses: [],
            };
        case L.contact_addresses:
            return {
                contactAddresses: [],
            };
        case L.contact_persons:
            return {
                contactPersons: [],
            };
        case L.countries:
            return {
                countries: [],
            };
        case L.state_list:
            return {
                countryStates: [],
            };
        case L.currencies:
            return {
                currencyGroups: {
                    favourite_items: [],
                    popular_items: [],
                    other_items: [],
                },
                currencies: [],
                currencyVersion: null,
            };
        case L.contacts:
            return {
                contacts: [],
                contactVersion: null,
            };
        case L.contact_groups:
            return {
                contactGroups: [],
                contactGroupVersion: null,
            };
        // case L.products:
        //     return {
        //         products: [],
        //         productVersion: null,
        //     };
        case L.accounts:
            return {
                accounts: [],
                accountVersion: null,
            };
        case L.terms:
            return {
                terms: [],
                termVersion: null,
            };
        case L.tag_groups:
            return {
                tagGroups: [],
                tagVersion: null,
            };
        case L.asset_types:
            return {
                assetTypes: [],
                assetVersion: null,
            };
        case L.fields:
            return {
                fields: readStorage(StorageKey.cache_custom_fields) || {
                    contact: [],
                    transaction: [],
                },
                fieldVersion: null,
            };
        case L.number_formats:
            return {
                numberFormats: [],
                numberFormatsVersion: null,
            };
        case L.locations:
            return {
                locations: [],
                locationVersion: null,
            };
        case L.tax_codes:
            return {
                taxCodes: [],
            };
        case L.settings:
            return {
                settings: {},
                settingVersion: null,
            };
        // case L.limits:
        //     return {
        //         limits: {},
        //     };
        case L.users:
            return {
                users: [],
            };
        case L.price_levels:
            return {
                priceLevels: [],
                priceLevelVersion: null,
            };
        case L.payment_methods:
            return {
                paymentMethods: [],
                paymentMethodVersion: null,
            };
        case L.advisors:
            return {
                advisors: [],
            };
        case L.product_list:
            return {
                productList: [],
                productListVersion: null,

                // Legacy support (safe to remove once tested)
                // products: [],
                // productVersion: null,
            };
        case L.product_detail:
            return {
                productDetail: { id: null },
                productDetailLastParams: {
                    product_id: null,
                    type: null,
                    contact_id: null,
                    date: null,
                    currency_code: null,
                },

                // Legacy support (safe to remove once tested)
                // product: { id: null },
                // productLastParams: {
                //     product_id: null,
                //     type: null,
                //     contact_id: null,
                //     date: null,
                //     currency_code: null,
                // },
            };
        case L.product_detail_list:
            return {
                productDetailList: [],
                productDetailListLastParams: {
                    product_ids: null,
                    type: null,
                    contact_id: null,
                    date: null,
                    currency_code: null,
                },
            };
        case L.product_groups:
            return {
                productGroups: [],
                productGroupVersion: null,
            };
        case L.classification_code_list:
            return {
                classificationCodeList: [],
            };
        case L.form_designs:
            return {
                formDesigns: [],
                formDesignsVersion: null,
            };
        case L.clients:
            return {
                clients: [],
            };
        case L.flow_streams:
            return {
                flowStreams: [],
            };
        default:
            return {};
    }
}
